const OurTestimonialsData = [
    {
        id: 1,
        name: "Melisa S.",
        title: "Izvrsna usluga",
        description: "Anida ima zlatne ruke! Svaka usluga koju sam dobila bila je savršena. Ambijent je prijatan i opuštajući, osjećala sam se kao kod kuće. Preporučujem je svakome tko traži stručnjaka za frizure. Sigurno se vraćam ponovo!",
        stars: 5,
    },
    {
        id: 2,
        name: "Adisa M.",
        title: "Profesionalnost i stručnost",
        description: "Anida je pravi profesionalac u svom poslu! Usluga je bila vrhunska, a njen pristup svakom klijentu je nevjerojatan. Ambijent salona je vrlo ugodan, savršeno za opuštanje. Osjećala sam se potpuno sigurno i zadovoljno. Definitivno ću se vratiti!",
        stars: 5,
    },
    {
        id: 3,
        name: "Admir N.",
        title: "Preporučujem bez razmišljanja",
        description: "Od trenutka kad sam kročio u salon, znao sam da sam na pravom mjestu. Anida je vrlo pažljiva i predana svom poslu. Moj novi look je nevjerojatan, a cijeli proces je bio ugodan. Ambijent salona je top, sve je moderno i opuštajuće. Svakako ću ponovo doći!",
        stars: 5
    }
];

export default OurTestimonialsData;
